export const YEARLINGS_BOBTAIL_WEBSITE = 'https://www.yearlingsbobtail.com'

// TODO: Eventually make it the Bobtail Dominoes Substack.
export const MAILING_LIST_WEBSITE = 'https://bobtail.substack.com'
